import { AddEmploymentScheduleToEmployeeRequestSchema } from '../schemas/employeeSchemas';
import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { useState } from 'react';

// Import existing types to use in function signatures
import { AddEmploymentScheduleToEmployeeRequest } from '../schemas/employeeSchemas';

/**
 * Hook for adding employment schedule to employee with built-in state management
 * Includes Zod validation for type safety
 */
export const useAddEmploymentScheduleToEmployee = () => {
  const { callAPI } = useAPI({ method: 'POST' }); // POST

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  /**
   * Add employment schedule to employee
   * @param data - The employment schedule data
   * @returns Promise with boolean indicating success
   */
  const action = async (data: AddEmploymentScheduleToEmployeeRequest): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    try {
      // Validate the input data
      const validatedData = /*  AddEmploymentScheduleToEmployeeRequestSchema.parse( */ data; /* ) */

      await callAPI(buildApiUrl('employee/employmentSchedule'), validatedData);
      return true;
    } catch (error) {
      console.error('Error in useAddEmploymentScheduleToEmployee:', error);
      setError(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    action,
  };
};
